import routes from "@/data/routes.json";

const publicPaths = new Set(routes.map(route => route.path));
const campaignKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
let entry = null;
const cleanCampaign = value => /^[\p{L}\p{N} _.,+\-]{1,100}$/u.test(value || "") ? value : null;

// Keep the entry context only in memory for this page opening. No cookies or storage.
export function captureLeadEntry() {
  if (entry || typeof window === "undefined") return;
  const url = new URL(window.location.href);
  let referrerHost = null;
  try {
    const referrer = new URL(document.referrer);
    if (!["nexxsite.pl", "www.nexxsite.pl"].includes(referrer.hostname)) referrerHost = referrer.hostname;
  } catch { /* Direct visit. */ }
  entry = {
    landing_path: publicPaths.has(url.pathname) ? url.pathname : "/",
    referrer_host: referrerHost,
    ...Object.fromEntries(campaignKeys.map(key => [key, cleanCampaign(url.searchParams.get(key))])),
  };
}

export function getLeadAttribution() {
  captureLeadEntry();
  return { ...entry, submission_path: publicPaths.has(window.location.pathname) ? window.location.pathname : "/" };
}
